<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("headings.labels") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" to="/labels/add">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="20"
      :loading="tableLoading"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-sm-center">{{ item.name }}</td>
          <td class="text-center">
            <span class="Cspan" :style="{ backgroundColor: item.color }"></span>
          </td>

          <td class="text-sm-center">
            <v-icon small title="edit" @click="handleEdit(item, index)">
              mdi-pencil</v-icon
            >
            <v-icon small title="delete" @click="handleDelete(item, item.id)">
              mdi-delete</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-xs-center mt-4">
      <v-pagination
        v-if="pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="10"
        @input="handlePagination"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { indexLabels, deleteLabel } from "@/api/labels";
import TableHeaders from "@/helpers/TableHeaders";
export default {
  name: "Labels",
  components: {},
  data() {
    return {
      slug: "",
      headers: [],
      items: [],
      pagination: {},
      tableLoading: true,
      itemIndex: ""
    };
  },

  mounted() {
    this.createTableHeaders();
    this.handleGetLabels();
  },
  watch: {
    "$route.query"() {
      this.handleGetLabels();
    }
  },
  methods: {
    handleEdit({ id }) {
      this.$router.push({ name: "editLabel", params: { id } });
    },
    handleDelete(item, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          deleteLabel(item.id)
            .then(() => {
              this.$delete(this.items, index);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    createTableHeaders() {
      const headersList = ["name", "color", "actions"];
      this.headers = TableHeaders(headersList);
    },
    handleGetLabels() {
      const queryObj = this.$route.query;
      indexLabels(queryObj)
        .then(res => {
          this.items = res.data.data;
          this.pagination = res.data.meta;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handlePagination(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    }
  }
};
</script>

<style scoped>
.Cspan {
  display: inline-block;
  width: 6rem;
  height: 1.7rem;
  border-radius: 100px;
}
</style>
